import api from '@/api/axios';
import { SentenceType, SubjectType } from '@/screens/SentenceSet/config';
import {
  Sentence,
  SentenceSetContextType,
} from '@/contexts/SentenceSetContext/types';

type SentenceSearchPayload = {
  term: string;
  termType: string;
  sentenceType: SentenceType;
  subjectType?: SubjectType;
  sentenceSubTypes: string[];
  searchSentencesPerPage: number;
  page: number;
};

export const getSentences = async (payload: SentenceSearchPayload) => {
  try {
    const { data } = await api.post<{
      totalCount: number;
      sentences: Sentence[];
    }>(`/api/sentences/search`, payload);
    return { isError: false, data };
  } catch (error) {
    throw { isError: true, error };
  }
};

export const getSelectedData = async (
  set: string,
  patientID: string | undefined,
  setId: string,
) => {
  if (!patientID) {
    throw { isError: true, error: 'Patient ID is required' };
  }
  try {
    const { data } = await api.get<SentenceSetContextType>(
      `/api/patients/${patientID}/${set}/${setId}`,
    );
    return { isError: false, data };
  } catch (error) {
    throw { isError: true, error };
  }
};
